import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  realEstateBoard: null,
  realEstateBoards: null,
  realEstateBoardsAll: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const realEstateBoardReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.REALESTATEBOARD_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.REALESTATEBOARD_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.REALESTATEBOARD_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default realEstateBoardReducer;
